<div class="wrapper">
    <mat-card class="form-card text-center mat-elevation-z6">
        <form [formGroup]="loginForm">
            <app-auth-top [title]="'Kancelaria Notarialna'"
                          [subTitle]="'Logowanie do panelu administracyjnego'" [closeLink]="'/'"></app-auth-top>
            <mat-card-content>
                <mat-form-field class="full-width" appearance="outline">
                    <mat-label>e-mail</mat-label>
                    <input matInput formControlName="email" name="email" type="email" placeholder="e-mail" #email>
                    <mat-hint align="end">
                        {{ email.value.length }} / {{ emailMaxLength }}
                    </mat-hint>
                    <mat-error *ngIf="emailAddress.errors?.['email'] || emailAddress.errors?.['required']">
                        Podaj prawidłowy adres e-mail.
                    </mat-error>
                    <mat-error *ngIf="email.value.length > emailMaxLength && !emailAddress.errors?.['email']">
                        Maksymalna długość adresu e-mail wynosi: {{ emailMaxLength }} znaków.
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="full-width pt-2" appearance="outline">
                    <mat-label>hasło</mat-label>
                    <input matInput formControlName="password" name="password" type="password" placeholder="password"
                           #passwd>
                    <mat-hint align="end">
                        {{ passwd.value.length }} / {{ passwordMaxLength }}
                    </mat-hint>
                    <mat-error *ngIf="password.errors?.['required']">
                        Podaj hasło.
                    </mat-error>
                    <mat-error *ngIf="passwd.value.length < passwordMinLength && !password.errors?.['required']">
                        Minimalna długość hasła wynosi: {{ passwordMinLength }} znaków.
                    </mat-error>
                    <mat-error *ngIf="passwd.value.length > passwordMaxLength">
                        Maksymalna długość hasła wynosi: {{ passwordMaxLength }} znaków.
                    </mat-error>
                </mat-form-field>
                <div class="pt-2">
                    <button type="button" class="full-width" mat-raised-button color="primary"
                            matTooltip="Login to app" matTooltipPosition="above" (click)="login()">
                        Zaloguj <i class="fa-solid fa-right-to-bracket"></i></button>
                </div>
            </mat-card-content>
            <div class="text-center py-4">
                <a class="link-secondary" routerLink="/password"
                   matTooltip="Link to forgot password page" matTooltipPosition="right">Zapomniane hasło?</a>
            </div>
        </form>
    </mat-card>
    <div class="mt-2">
        <app-company-link></app-company-link>
    </div>
</div>
